<template>
  <layout-content>
    <template #headerTitle>
      <h1 class="layout-content-header-text">{{$route.meta.label}}</h1>
      <!--  查询表单  -->
      <div class="alarm-record-container">
        <el-form :inline="true" :model="search">
<!--          <el-form-item label="报警站点">-->
<!--            <el-select v-model="search.siteId" size="small" style="width: 200px" placeholder="请选择报警站点">-->
<!--              <el-option-->
<!--                v-for="option in filterSites"-->
<!--                :key="option.id"-->
<!--                :label="option.name"-->
<!--                :value="option.id"/>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <el-form-item label="加和因子">
            <el-select v-model="search.factorConfigId" size="small" style="width: 200px" placeholder="请选择加和因子">
              <el-option
                v-for="option in factorList"
                :key="option.id"
                :label="option.factorName"
                :value="option.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="报警级别">
            <el-select v-model="search.alarmLevel" placeholder="请选择报警级别" clearable size="small" style="width: 200px">
              <el-option
                v-for="option in levelOptions"
                :key="option.value"
                :label="option.label"
                :value="option.value"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="orange" size="small" @click="handleSearch" icon="el-icon-search">查询</el-button>
            <el-button type="primary" size="small" @click="handleReset" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </template>

    <template #body>
      <data-wrapper>
        <el-table
          ref="table" height="100%"
          border :data="list"
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table"
          style="width:100%">
          <el-table-column label="序号" width="60" align="center" fixed>
            <template v-slot="{$index}">{{ formatTableIndex($index) }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="日期" show-overflow-tooltip align="center"/>
          <el-table-column prop="siteName" label="报警站点" align="center">
<!--            <template v-slot="{row}">-->
<!--              {{ filterSites.find((opt) => opt.id === row.siteId) ? filterSites.find((opt) => opt.id === row.siteId).name : '&#45;&#45;' }}-->
<!--            </template>-->
          </el-table-column>
          <el-table-column prop="deviceName" label="监测仪名称" align="center"/>
          <el-table-column prop="factorConfigId" label="加和因子名称" align="center">
            <template v-slot="{row}">
              {{ factorList.find((opt) => opt.id === row.factorConfigId) ? factorList.find((opt) => opt.id === row.factorConfigId).factorName : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="alarmLevel" label="报警级别" align="center">
            <template v-slot="{row}">
              {{ levelOptions.find((opt) => opt.value === row.alarmLevel) ? levelOptions.find((opt) => opt.value === row.alarmLevel).label : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="realValue" label="实测值" align="center">
            <template v-slot="{row}">
              <span :style="{ color: 'red' }">{{row.realValue}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="warnValue" label="报警值" align="center"/>
          <el-table-column prop="realSiteNum" label="实测报警站点数" align="center"/>
        </el-table>
      </data-wrapper>
    </template>

    <template #footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[20, 50, 100, 200, 500]"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next"
        background
        style="float:right">
      </el-pagination>
    </template>
  </layout-content>
</template>

<script>
import LayoutContent from '../../../components/Layout/Content'
import DataWrapper from '../../../components/Data/DataWrapper'
import BaseStore from '../../../components/BaseStore'

export default {
  name: 'AlarmRecord',
  routeInfo: {
    label: '报警记录',
    icon: 'fa fa-eye'
  },
  mixins: [BaseStore],
  components: {DataWrapper, LayoutContent},
  data () {
    return {
      search: {
        siteId: '',
        alarmLevel: '',
        factorConfigId: ''
      },
      levelOptions: [
        {value: '2', label: '二级报警'},
        {value: '3', label: '三级报警'}
      ],
      factorList: [],
      list: [],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  methods: {
    // 初始化加载
    initBase () {
      this.initDefaultData()
      this.fetchData()
    },
    // 加载默认数据
    initDefaultData () {
      this.$api['FactorRuleConfig'].getFactorConfigList().then((res) => { this.factorList = res || [] })
    },
    // 获取数据
    fetchData () {
      this.changeLoadStatus(true)
      const params = {
        ...this.search,
        size: this.pagination.pageSize,
        current: this.pagination.pageNum
      }
      this.$api['AlarmRecord'].pageRecordList(params)
        .then(res => {
          this.list = res.records || []
          this.pagination.total = res.total || 0
        })
        .catch(console.error)
        .finally(() => {
          this.changeLoadStatus(false)
        })
    },
    // 查询数据
    handleSearch () {
      this.pagination.pageNum = 1
      this.fetchData()
    },
    // 重置查询
    handleReset () {
      this.pagination.pageNum = 1
      // this.search.siteId = ''
      this.search.factorConfigId = ''
      this.search.alarmLevel = ''
      this.fetchData()
    },
    // 分页数量改变
    handleSizeChange (pageSize) {
      this.pagination.pageSize = pageSize
      this.fetchData()
    },
    // 分页页码改变
    handleCurrentChange (currentPage) {
      this.pagination.pageNum = currentPage
      this.fetchData()
    },
    // 格式化表格序号
    formatTableIndex (index) {
      return (this.pagination.pageNum - 1) * this.pagination.pageSize + index + 1
    }
  },
  created () {
    this.initBase()
  }
}
</script>

<style lang="scss" scoped>
.alarm-record-container {
  gap:12px;
  float:left;
  display:flex;
  margin-left:2em;
  margin-top: -4px;
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/05AlarmRule/03AlarmRecord/index.vue